import { render, staticRenderFns } from "./flowy-vue.vue?vue&type=template&id=5a33012e&"
import script from "./flowy-vue.vue?vue&type=script&lang=js&"
export * from "./flowy-vue.vue?vue&type=script&lang=js&"
import style0 from "./flowy-vue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports